import { create } from "zustand";
import { type AchievementType, type AchievementIcon } from "@/constants/achievements";

export interface RealAchievement {
  id: string;
  title: string;
  description: string;
  type: AchievementType;
  icon: AchievementIcon;
  progress: number;
  isCompleted: boolean;
  pointsReward: number;
  isClaimed?: boolean;
}

interface AchievementsState {
  achievements: RealAchievement[];
  isLoading: boolean;
  lastFetched: number;
  isFetching: boolean;
  refreshTrigger: number;

  setAchievements: (achievements: RealAchievement[]) => void;
  setIsLoading: (isLoading: boolean) => void;
  setLastFetched: (timestamp: number) => void;
  setIsFetching: (isFetching: boolean) => void;
  triggerRefresh: () => void;
}

export const useAchievementsStore = create<AchievementsState>((set) => ({
  achievements: [],
  isLoading: true,
  lastFetched: 0,
  isFetching: false,
  refreshTrigger: 0,

  setAchievements: (achievements) => set({ achievements }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setLastFetched: (timestamp) => set({ lastFetched: timestamp }),
  setIsFetching: (isFetching) => set({ isFetching }),
  triggerRefresh: () => set((state) => ({ refreshTrigger: state.refreshTrigger + 1 })),
}));
